import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { getLanguagePreferences } from 'app/constants/language-translate';

import { HelperService, HTTPService } from 'app/services';

@Component({
  selector: 'app-unsubscribe-contact',
  templateUrl: './unsubscribe-contact.component.html',
  styleUrls: ['./unsubscribe-contact.component.scss'],
})
export class UnsubscribeContactComponent implements OnInit {
  @Input() isPassingData: boolean = false;
  @Input() token: string = '';
  @Input() data: any = {};

  company: any = {};
  contact = {
    contactType: '',
    contactValue: '',
    isSubscribe: false,
  };

  year: number = new Date().getFullYear();
  title: string = '';
  message: string = '';
  isLoading: boolean = true;
  unSubscribing: boolean = false;
  currentLang: string = getLanguagePreferences().currentLang;

  constructor(private activatedRoute: ActivatedRoute, private httpService: HTTPService, private helperService: HelperService, private translate: TranslateService) { }

  ngOnInit() {
    this.token = this.activatedRoute.snapshot.paramMap.get('appt_conf_token');
    this.currentLang = this.helperService.validatePreferredLang(this.currentLang);
    this.translate.use(this.currentLang);
    if (this.token || this.isPassingData) {
      this.getData();
    }
  }

  async getData(forceFetch: boolean = false) {
    let company = null,
      contact = null;

    try {
      this.isLoading = true;

      if (this.isPassingData && !forceFetch) {
        company = this.data && this.data.company;
        contact = this.data && this.data.contact;
      } else {
        const data: any = await this.httpService.getDataForUnsubscribe(this.token);

        company = data.company;
        contact = data.contact;
      }

      this.isLoading = false;
      this.company = company;

      if (contact && contact.contactInfo) {
        this.contact = {
          contactType: contact.contactInfo.type,
          contactValue: contact.contactInfo.value,
          isSubscribe: contact.contactInfo.isActive,
        };

        if (this.contact.isSubscribe) {
          if (this.currentLang === 'fr') {
            this.title = `Se désabonner de l'email`;
            this.message = `
          <p class="mb-2">Nous sommes désolés de vous voir partir, mais nous sommes là quand vous êtes prêt pour plus!</p>
          <br>
          <p class="mb-2">Cliquez sur le bouton ci-dessous pour arrêter de recevoir des e-mails sur ${this.contact.contactValue}</p>
        `;
          } else {
            this.title = `Unsubscribe email`;
            this.message = `
          <p class="mb-2">We're sad to see you go, but we're here when you're ready for more!</p>
          <br>
          <p class="mb-2">Click on the below button to stop receiving email on ${this.contact.contactValue}</p>
        `;
          }
        } else {
          if (this.currentLang === 'fr') {
            this.title = `Email désabonné`;
            this.message = `
          <p class="mb-2">Vous vous êtes désabonné avec succès des e-mails de ${this.company.name}</p>
          <br>
          <p class="mb-2">Contactez ${this.company.name} pour reprendre la réception des e-mails d'estimation et de rendez-vous</p>
        `;
          } else {
            this.title = `Email Unsubscribed`;
            this.message = `
            <p class="mb-2">You have successfuly unsubscribed from ${this.company.name}'s emails</p>
            <br>
            <p class="mb-2">Contact ${this.company.name} in order to resume receiving estimate and appointment emails</p>
          `;
          }
        }
      }
    } catch (err) {
      console.log(err);
    } finally {
      this.isLoading = false;
    }
  }

  handleSubscribe() {
    this.unSubscribing = true;
    this.httpService
      .unsubscribeContact(this.token)
      .then(
        (res) => {
          this.getData(true);
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        this.unSubscribing = false;
      });
  }
}
